import { render } from "./Q2Simple.vue?vue&type=template&id=f7ad0e96"
import script from "./Q2Simple.vue?vue&type=script&lang=js"
export * from "./Q2Simple.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__